<template>
  <div>
    <div class="card mb-3 w-100">
      <p class="card-titulo font-weight-bold p-2 h5"> 
        Formas de Pagamento
      </p>
      <div class="card-conteudo mr-3 ml-3">
        <div v-for="dados in dadosDoCard" 
             :key="dados.titulo" 
             class="d-flex justify-content-between align-items-center mb-3">
          <span class="formas-de-pagamento">
            {{ dados.titulo }}
          </span>
          <div class="card-valor font-weight-bold text-left">
            <input v-money="money"
                   :value="dados.valor"
                   disabled
                   size="sm"
                   trim>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { VMoney } from 'v-money'

  export default {
    name: "CardFormasDePagamento",
    directives: {
      money: VMoney
    },
    props: {
      propFormaPg: {type: Object, default: null },
    },
    data () {
      return {
        dadosDoCard: [],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
    computed: {
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      }
    },
    watch: {
      'cxSaldo.pedidos.saldoTotal' () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.dadosDoCard = []
        this.dadosDoCard.push(this.cxSaldo.formaPg.cartaoCredito)
        this.dadosDoCard.push(this.cxSaldo.formaPg.cartaoDebito)
        this.dadosDoCard.push(this.cxSaldo.formaPg.cheque)
        this.dadosDoCard.push(this.cxSaldo.formaPg.dinheiro)
        this.dadosDoCard.push(this.cxSaldo.formaPg.pix)
        this.dadosDoCard.push(this.cxSaldo.formaPg.outros)
      }
    }
  }
</script>

<style scoped>
    .card {
        box-shadow: 3px 3px 0px rgba(0, 0, 0, 0.3);
    }
    .card .card-titulo {
        background-color: #C6C6C6;
    }
    .formas-de-pagamento {
       width:100px;
    }
    .card .card-conteudo .card-valor{
        font-size: 1.3rem;
    }
    /* .card-valor input {
      font-size: 1.3rem;
      font-weight: bold;
      width:200px;
      padding-left:70px;
    } */
    .card-valor input {
      font-size: 1.3rem;
      font-weight: bold;
      text-align: right;
      margin-right: 20px;
      width:100%;
    }
</style>